// extracted by mini-css-extract-plugin
export default {"resItemVideo":"index_resItemVideo__ODtC+","flag":"index_flag__ui0Kw"};